// FacebookAuthCallback.jsx
// This is a relay page. Facebook redirects here (frontend URL) with ?code=...
// We immediately forward the code to the Flask backend, which does the real OAuth exchange
// and then redirects to /auth/callback (existing flow).
import { useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const FacebookAuthCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error || !code) {
      // Facebook denied access or something went wrong
      window.location.href = "/login?error=facebook_denied";
      return;
    }

    // Forward the code to the Flask backend which does the real exchange,
    // sets the JWT cookie, and redirects to /auth/callback
    window.location.href = `${BACKEND_URL}/auth/facebook/callback?code=${encodeURIComponent(code)}`;
  }, []);

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
      color: "white",
      fontSize: "1.1rem",
      gap: "12px"
    }}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="#1877F2"
        style={{ animation: "spin 1s linear infinite" }}
      >
        <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
      </svg>
      Completing Facebook sign-in…
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default FacebookAuthCallback;
